import React from 'react'
import img5 from '../../img/img2.jpg'
import '../Projects.css';


function Project5() {

  return (
    <>

      <div className='container-projects'>
        <img src={img5} />
        <div className='project-description'>
          <h2 className='titulo-projects'>Renovation </h2>
          The construction of the main entrance door for the residence "Casa de los Rodríguez" was carried out with the purpose of enhancing the security, functionality, and aesthetics of the home's entrance. This project involved installing a new door that not only provided protection and privacy but also complemented the architectural design and style of the house.
          <h1>Renovation Details:</h1>
          <h1>Initial Evaluation and Planning:</h1><br></br>
          Site Inspection: A detailed inspection of the area where the new door would be located was conducted, taking into consideration the size of the space, existing structure, and security needs.<br></br><br></br>
          Design and Specifications: In collaboration with the homeowners, a customized design was developed that incorporated advanced security features and aesthetically appealing elements. Material options such as wood, steel, and aluminum were discussed, along with finishes and colors that harmonized with the house facade.
        </div>
      </div>
    </>
  )



}

export default Project5